// extracted by mini-css-extract-plugin
export default {"tooltip":"AW-z","arrow":"BW-z"};